<h2 class="no-notification" [@openClose]="areNotificationsEmpty ? 'open' : 'closed'">All set!</h2>
<div class="list-view-items" *ngIf="!areNotificationsEmpty">
  <app-notification-list-entry *ngFor="let notification of this.notificationService.notifications; let index = index"
                               [notification]="notification" [indexTag]="index"
                               (dismissNotificationEvent)="dismissNotification(index)"
                               (closeNotificationPopup)="closePopUp()"></app-notification-list-entry>
</div>


